<template>
    <section class="home-chat">
      <v-container>
        <v-row>
          <v-col>
            <div class="section__title">
              <div class="section__title-text">コメントについて</div>
            </div>
          </v-col>
        </v-row>
        <v-row class="home-chat__contents">
          <v-col md="10" class="home-chat__contents-text">
            <p class='text-h6'>松尾中学校での思い出や、山武望洋中学校への期待の気持ちを是非書き込んでみてください。</p>
            <p class='text-h6'>投稿されたコメントは「<router-link v-on:click="scrollTop" to="/messageList" >みんなのコメント</router-link>」からご覧に慣れます。</p>
          </v-col>
        </v-row>
        <AppButton
          :button-text="buttonText"
          :url="url"
          class="home-chat__contents-btn"
          v-on:click="scrollTop"
        />
      </v-container>
    </section>
</template>

<script>
import AppButton from './AppButton.vue'

export default {
  name: 'HomeChat',
  data () {
    return {
      buttonText: '詳しくみる',
      url: '/submitMessage',
      }
    },
  components: {
    AppButton
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "instant"
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/common/common.scss';

.section__title-text {
  margin-top: 30px;
  padding: 1rem 2rem;
  border-top: 3px solid #000;
  border-bottom: 3px solid #000;
  text-align:  center;
}
.home-chat__contents {

  margin-top: 20px;
  justify-content: center;

  &-img {
    text-align: center;
  }

  &-text {
    word-wrap: break-word;
    text-align: center;
  }
  &-btn {
    margin-bottom: 30px;
  }
}
</style>
